var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          staticClass: "mt-6",
          attrs: { action: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.updateEstimateSetting.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "sw-input-group",
            {
              attrs: {
                label: _vm.$t(
                  "settings.customization.estimates.estimate_prefix"
                ),
                error: _vm.estimatePrefixError,
              },
            },
            [
              _c("sw-input", {
                staticStyle: { "max-width": "30%" },
                attrs: { invalid: _vm.$v.estimates.estimate_prefix.$error },
                on: {
                  input: function ($event) {
                    return _vm.$v.estimates.estimate_prefix.$touch()
                  },
                  keyup: function ($event) {
                    return _vm.changeToUppercase("ESTIMATES")
                  },
                },
                model: {
                  value: _vm.estimates.estimate_prefix,
                  callback: function ($$v) {
                    _vm.$set(_vm.estimates, "estimate_prefix", $$v)
                  },
                  expression: "estimates.estimate_prefix",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              staticClass: "mt-6 mb-4",
              attrs: {
                label: _vm.$t(
                  "settings.customization.estimates.default_estimate_email_body"
                ),
              },
            },
            [
              _c("base-custom-input", {
                attrs: { fields: _vm.mailFields },
                model: {
                  value: _vm.estimates.estimate_mail_body,
                  callback: function ($$v) {
                    _vm.$set(_vm.estimates, "estimate_mail_body", $$v)
                  },
                  expression: "estimates.estimate_mail_body",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              staticClass: "mt-6 mb-4",
              attrs: {
                label: _vm.$t(
                  "settings.customization.estimates.company_address_format"
                ),
              },
            },
            [
              _c("base-custom-input", {
                attrs: { fields: _vm.companyFields },
                model: {
                  value: _vm.estimates.company_address_format,
                  callback: function ($$v) {
                    _vm.$set(_vm.estimates, "company_address_format", $$v)
                  },
                  expression: "estimates.company_address_format",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              staticClass: "mt-6 mb-4",
              attrs: {
                label: _vm.$t(
                  "settings.customization.estimates.shipping_address_format"
                ),
              },
            },
            [
              _c("base-custom-input", {
                attrs: { fields: _vm.shippingFields },
                model: {
                  value: _vm.estimates.shipping_address_format,
                  callback: function ($$v) {
                    _vm.$set(_vm.estimates, "shipping_address_format", $$v)
                  },
                  expression: "estimates.shipping_address_format",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              staticClass: "mt-6 mb-4",
              attrs: {
                label: _vm.$t(
                  "settings.customization.estimates.billing_address_format"
                ),
              },
            },
            [
              _c("base-custom-input", {
                attrs: { fields: _vm.billingFields },
                model: {
                  value: _vm.estimates.billing_address_format,
                  callback: function ($$v) {
                    _vm.$set(_vm.estimates, "billing_address_format", $$v)
                  },
                  expression: "estimates.billing_address_format",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-button",
            {
              staticClass: "mt-4",
              attrs: {
                disabled: _vm.isLoading,
                loading: _vm.isLoading,
                variant: "primary",
                type: "submit",
              },
            },
            [
              !_vm.isLoading
                ? _c("save-icon", { staticClass: "mr-2" })
                : _vm._e(),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("settings.customization.save")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("sw-divider", { staticClass: "mt-6 mb-8" }),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "relative w-12" },
          [
            _c("sw-switch", {
              staticClass: "absolute",
              staticStyle: { top: "-20px" },
              on: { change: _vm.setEstimateSetting },
              model: {
                value: _vm.estimateAutogenerate,
                callback: function ($$v) {
                  _vm.estimateAutogenerate = $$v
                },
                expression: "estimateAutogenerate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ml-4" }, [
          _c(
            "p",
            { staticClass: "p-0 mb-1 text-base leading-snug text-black" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "settings.customization.estimates.autogenerate_estimate_number"
                    )
                  ) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "p-0 m-0 text-xs leading-tight text-gray-500",
              staticStyle: { "max-width": "480px" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "settings.customization.estimates.estimate_setting_description"
                    )
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }